import React, { useEffect, useState } from 'react'
import GoogleMapReact from 'google-map-react'
import { Container } from './MapView.style'
import Marker from '@components/LotsMap/Marker'
import useLanguage from '@hooks/useLanguage.hook'
import { MapLocation } from '@customTypes/mapLocation.interface'
import MapLotCard from '../MapLotCard/MapLotCard.component'
import { CarpayLot } from '@customTypes/carpayLot.interface'

// munchen
const DEFAULT_LAT = 48.137154
const DEFAULT_LNG = 11.576124
const GOOGLE_MAPS_KEY = process.env.VITE_GOOGLE_MAPS_KEY || ''

interface Props {
    publicLots: CarpayLot[]
    searchedLocation?: MapLocation | null
    setLotMapSelected: (lotId: string) => void
    onLotClick: (lot: CarpayLot) => void
}

const MapView: React.FC<Props> = ({ publicLots = [], searchedLocation, onLotClick, setLotMapSelected }) => {
    const [lng] = useLanguage()
    const [mapPosition, setMapPosition] = useState({ lat: DEFAULT_LAT, lng: DEFAULT_LNG })
    const [selectedLot, setSelectedLot] = useState<CarpayLot | null>(null)
    const [map, setMap] = useState<any | null>(null)
    const [zoomLevel, setZoomLevel] = useState<number>(6)

    const markers: MapLocation[] = publicLots.map((lot) => ({
        lotId: lot.lot_id,
        lat: lot.latitude,
        lng: lot.longitude
    }))

    const onMarkerClick = async (lotId: string) => {
        const lot = publicLots.find((lot) => lot.lot_id === lotId)
        if (!lot) return

        setSelectedLot(lot)
        setLotMapSelected(lotId)
    }

    useEffect(() => {
        if (!searchedLocation || !map) return
        setMapPosition(searchedLocation)
        setZoomLevel(12)
        map.panTo(searchedLocation)
    }, [map])

    if (!GOOGLE_MAPS_KEY) return null
    return (
        <Container>
            <GoogleMapReact
                bootstrapURLKeys={{ key: GOOGLE_MAPS_KEY, language: lng, libraries: ['places'] }}
                center={{ lat: mapPosition.lat, lng: mapPosition.lng }}
                zoom={zoomLevel}
                yesIWantToUseGoogleMapApiInternals
                onGoogleApiLoaded={({ map }) => {
                    setMap(map)
                }}
            >
                {markers.map((marker) => (
                    <Marker
                        id={marker.lotId}
                        key={marker.lotId}
                        lat={marker.lat}
                        lng={marker.lng}
                        onMarkerClick={onMarkerClick}
                    />
                ))}
            </GoogleMapReact>
            {selectedLot && <MapLotCard lot={selectedLot} onLotClick={onLotClick} />}
        </Container>
    )
}
export default MapView
